import { jsx as y } from "react/jsx-runtime";
import { useContext as g } from "react";
import { FormContext as b } from "../FormContext.js";
import { formatObjectKey as x } from "../../../helpers/formatting/formatObjectKey.js";
import "../../ValidationMessage/ValidationMessage.js";
import "../../../index-2QXL0WYc.js";
import { IressValidationSummary as S } from "../../ValidationMessage/ValidationSummary/ValidationSummary.js";
const h = (c) => {
  const t = g(b);
  if (!t)
    throw new Error("FormValidationSummary must be used within a IressForm");
  const u = Object.entries(t.errorMessages).filter(([, o]) => !!o).map(([o, d]) => {
    var a, m, i, n;
    const s = `${t == null ? void 0 : t.id}__${o}`, r = document.getElementById(s), l = r == null ? void 0 : r.labels, p = Array.from(l ?? []), e = (a = r == null ? void 0 : r.closest("fieldset")) == null ? void 0 : a.querySelector("legend"), f = `${((i = (m = p[0]) == null ? void 0 : m.dataset) == null ? void 0 : i.name) ?? ((n = e == null ? void 0 : e.dataset) == null ? void 0 : n.name) ?? x(o)}: `;
    return {
      linkToTarget: s,
      message: `${f}${d}`
    };
  });
  return /* @__PURE__ */ y(S, { ...c, messages: u });
};
export {
  h as FormValidationSummary
};
